module.exports = __webpack_public_path__ + "img/pet_reserve.5f3fa6f7.svg";